export const MODAL_TYPES = {
  DUPLICATE_CAMPAIGN: 'DUPLICATE_CAMPAIGN',
  NEW_CAMPAIGN: 'NEW_CAMPAIGN',
  EDIT_CAMPAIGN: 'EDIT_CAMPAIGN',
  OPEN_CAMPAIGN: 'OPEN_CAMPAIGN',
} as const;

export const WINDOW_EVENTS = {
  OPEN_AUDIENCE_ACTIVATION_MODAL: 'OPEN_AUDIENCE_ACTIVATION_MODAL',
};
